import facebook from './_assets/facebook.png'
import facebook2X from './_assets/facebook@2x.png'
import linkedin from './_assets/linkedin.png'
import linkedin2X from './_assets/linkedin@2x.png'
import twitter from './_assets/twitter.svg'
import twitter2X from './_assets/twitter@2x.svg'
import messenger from './_assets/messenger.png'
import messenger2X from './_assets/messenger@2x.png'
import whatsapp from './_assets/whatsapp.png'
import whatsapp2X from './_assets/whatsapp@2x.png'
import boostClass from './_assets/boost-icon.svg'

const socialMediaIcons = {
  facebook,
  facebook2X,
  linkedin,
  linkedin2X,
  twitter,
  twitter2X,
  messenger,
  messenger2X,
  whatsapp,
  whatsapp2X,
  boostClass
}

export default socialMediaIcons
